import React from "react";
import "./Portfolio.css";
import { Projects } from "../DATA/Data";
import PCard from "./P_Card";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h2>My Recent Project</h2>
      <hr />
      <div className="portfolio-container">
        {Projects.map((project) => (
          <PCard
            name={project.name}
            img={project.img}
            description={project.description}
            key={project.id}
            a={project.a}
            link={project.link}
            preview={project.preview}
          />
        ))}
      </div>
      <hr />
    </section>
  );
};

export default Portfolio;
